// RealTermsToggle.tsx — "Inflationsbereinigung" (Feature 2): a session-only toggle +
// inflation-rate override. Rendered in both the Cockpit results panel and the Vergleich
// page, both reading/writing the SAME app-level state (see app.tsx) — flipping it in one
// place is reflected in the other, since neither owns a private copy. Presentation only:
// nothing here touches the engine result, localStorage, or the API — see
// lib/realTerms.ts for the actual deflation.
import { NumberField } from './NumberField.js';
import { ToggleField } from './ToggleField.js';
import { useExplain } from './Hint.js';
import type { RealTermsSettings } from '../lib/realTerms.js';

export interface RealTermsToggleProps {
  settings: RealTermsSettings;
  onChange: (settings: RealTermsSettings) => void;
}

export function RealTermsToggle({ settings, onChange }: RealTermsToggleProps) {
  const showExplanations = useExplain();
  return (
    <div class="field">
      <ToggleField
        label="Inflationsbereinigt (heutige Kaufkraft)"
        checked={settings.enabled}
        onChange={(v) => onChange({ ...settings, enabled: v })}
        hint={
          !showExplanations
            ? undefined
            : settings.enabled
              ? 'Kennzahlen, Verlauf, Wasserfall, Vergleichstabelle und Monte-Carlo werden auf die Kaufkraft des Startdatums abgezinst. Das Ereignisprotokoll bleibt nominal. Prozentwerte und Datumsangaben (inkl. Break-even) bleiben unverändert.'
              : 'Zeigt alle Beträge in der Kaufkraft von heute statt nominal an — die Berechnung selbst bleibt unverändert.'
        }
      />
      {settings.enabled ? (
        <NumberField
          label="Inflationsrate"
          unit="%"
          value={settings.inflationPercent}
          onChange={(v) => onChange({ ...settings, inflationPercent: v })}
          min={0}
          max={20}
          step={0.1}
          sliderMax={10}
          sliderStep={0.1}
        />
      ) : null}
    </div>
  );
}
